import { Card } from "@/components/ui/card";
import { BarChart3, Zap, Package } from "lucide-react";

export function CompanyUsageTab() {
  return (
    <div className="space-y-6">
      <Card className="p-4 sm:p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <BarChart3 className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Usage & Activity</h3>
            <p className="text-sm text-muted-foreground">Company feature usage overview</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <Card className="p-4 border border-border">
            <div className="flex items-center gap-2 mb-2">
              <Zap className="h-4 w-4 text-warning" />
              <p className="text-sm font-medium text-foreground">Load Boosts</p>
            </div>
            <p className="text-2xl font-bold text-foreground">—</p>
            <p className="text-xs text-muted-foreground mt-1">Boost history coming soon</p>
          </Card>

          <Card className="p-4 border border-border">
            <div className="flex items-center gap-2 mb-2">
              <Package className="h-4 w-4 text-primary" />
              <p className="text-sm font-medium text-foreground">Loads Posted</p>
            </div>
            <p className="text-2xl font-bold text-foreground">—</p>
            <p className="text-xs text-muted-foreground mt-1">Usage metrics coming soon</p>
          </Card>
        </div>
      </Card>
    </div>
  );
}
